/* eslint-disable no-console */
import { LogEntry, LogTransport } from '../types';

export class ConsoleTransport implements LogTransport {
  async log(entry: LogEntry): Promise<void> {
    const { timestamp, level, message, meta, correlationId, module } = entry;

    const prefix = `[${timestamp}] [${level.toUpperCase()}] [${module}]`;
    const correlationSuffix = correlationId ? ` [${correlationId}]` : '';

    const logMethod = this.getConsoleMethod(level);

    if (meta && Object.keys(meta).length > 0) {
      logMethod(`${prefix} ${message}${correlationSuffix}`, meta);
    } else {
      logMethod(`${prefix} ${message}${correlationSuffix}`);
    }
  }

  private getConsoleMethod(level: string): (...args: any[]) => void {
    switch (level) {
      case 'debug':
        return console.debug;
      case 'info':
        return console.info;
      case 'warn':
        return console.warn;
      case 'error':
        return console.error;
      default:
        return console.log;
    }
  }
}
